import type { Environment } from "../../types";

export interface QueueRow {
  solution: string;
  environment: Environment;
  playerId?: string;
  clientIp?: string;
  kioskId?: string;
}

export function QueueTable({ rows }: { rows: QueueRow[] }) {
  return (
    <table id="queuesTable">
      <thead>
        <tr>
          <th>Solution</th>
          <th>Environment</th>
          <th>PlayerId</th>
          <th>ClientIp</th>
          <th>KioskId</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={idx}>
            <td>{row.solution}</td>
            <td>{row.environment}</td>
            <td>{row.playerId}</td>
            <td>{row.clientIp}</td>
            <td>{row.kioskId}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
